import React, { Component } from 'react'
import '../../card.css'

class Card extends Component {

    handleClick(){
        this.props.history.push("/selected-agac?i=" + this.props.id)
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} class="card-outer-container result-card-outer-container">
                <div class="card-inner-container">
                    <div class="card-image-container">
                        <img class="card-image" alt={this.props.name} src={this.props.image} />
                    </div>
                    <div class="card-text-container">
                        <p class="card-text">{this.props.name}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Card